import { render, staticRenderFns } from "./CashGive.vue?vue&type=template&id=1f3d5ba5&scoped=true&"
import script from "./CashGive.vue?vue&type=script&lang=js&"
export * from "./CashGive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3d5ba5",
  null
  
)

export default component.exports